import EmptyPage       from '../components/empty_page';
import InfoPage        from './info_page';
import InvoicePage     from './invoice_page';
import renderPage      from '../components/render_page';
import Tab             from './tab';

import AddFilePage     from '../add/file_page';
import AddOnePage      from '../add/one_page';
import AddPage         from '../add/add_page';
import KioskModePage   from '../add/kiosk_mode_page';
import KioskModePolicy from '../add/kiosk_mode_policy';


export default {
  path:         '/:businessID/contacts',
  component:    renderPage(EmptyPage),
  name:         'ContactsList',
  onlyTab:      true,
  tabComponent: {
    component: Tab,
    name:      'contacts'
  },
  routes: [
    {
      path:         'add',
      component:    renderPage(AddPage),
      name:         'AddPage',
      tabComponent: {
        component: Tab,
        name:      'contacts'
      },
      routes: [
        {
          path:         'one',
          name:         'AddContact',
          component:    renderPage(AddOnePage),
          tabComponent: {
            component: Tab,
            name:      'contacts'
          }
        },
        {
          path:      'kiosk',
          name:      'KioskMode',
          component: renderPage(KioskModePage),
          routes:    [
            {
              path:      'policy',
              component: renderPage(KioskModePolicy)
            }
          ]
        },
        {
          path:         'file',
          name:         'AddFromFile',
          component:    renderPage(AddFilePage),
          tabComponent: {
            component: Tab,
            name:      'contacts'
          }
        }
      ]

    },
    {
      path:         ':contactID',
      component:    renderPage(InfoPage),
      name:         'ContactInfo',
      tabComponent: {
        component: Tab,
        name:      'contacts'
      },
      routes: [
        {
          path:         'invoice',
          component:    renderPage(InvoicePage),
          name:         'Invoice',
          tabComponent: {
            component: Tab,
            name:      'contacts'
          }
        }
      ]
    }
  ]
};
